export const setToken = (token) => {
  localStorage.setItem("token", token);
};

export const getToken = () => {
  return localStorage.getItem("token");
};

export const removeToken = () => {
  localStorage.removeItem("token");
};

// ✅ check if logged in
export const isLoggedIn = () => {
  return !!localStorage.getItem("token");
};